// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2iTHg","visuallyhidden":"_3Lr6R","hide-text":"_3UHbW","center":"_2BlnK","noprint":"_1tNaU","button":"_1zHRp","streamer":"_2XsmH","title":"_3tqj-","header":"_1EEBV","headerClickable":"_2sE3n","root":"_1ilWm","body":"Mxw0b","rootButtonToggleable":"_10INT","rootIsCollapsed":"_3UcGK","rootHeaderToggleable":"_2KAB9"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-factbox/styles/default.scss
 ** module id = 998
 ** module chunks = 2
 **/